import { useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from '../index.module.scss'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import CommonModal from '../../atoms/modal/CommonModal'
import Photographer from '../VendorSurveyModals/Photographer'
import Caterer from '../VendorSurveyModals/Caterer'
import HairStylist from '../VendorSurveyModals/HairStylist'
import MakeupArtist from '../VendorSurveyModals/MakeupArtist'
import Florist from '../VendorSurveyModals/Florist'
import DJMusician from '../VendorSurveyModals/DJMusician'
import DecorRentals from '../VendorSurveyModals/DecorRentals'
import Officiant from '../VendorSurveyModals/Officiant'
import { Transportation } from '../VendorSurveyModals/Transportation'
import { clearSurveyData } from '../../../features/kazooEventSlice'

const VENDOR_TABS = [
	{ id: 'Photographer', label: 'Photographer', Component: Photographer },
	{ id: 'Caterer', label: 'Caterer', Component: Caterer },
	{ id: 'HairStylist', label: 'Hair Stylist', Component: HairStylist },
	{ id: 'MakeupArtist', label: 'Makeup Artist', Component: MakeupArtist },
	{ id: 'Florist', label: 'Florist', Component: Florist },
	{ id: 'DJMusician', label: 'DJ/Musician', Component: DJMusician },
	{ id: 'DecorRentals', label: 'Decor/Rentals', Component: DecorRentals },
	{
		id: 'Transportation',
		label: 'Transportation',
		Component: Transportation,
	},
	{ id: 'Officiant', label: 'Officiant', Component: Officiant },
]

const Modal = ({ activeModal, closeAllModals }) => {
	const dispatch = useDispatch()
 	const businessTypes = useSelector((s) => s.auth.user?.businessTypes)
	const surveyData = useSelector((s) => s.kazooEvent.surveyData)

	const ActiveComponent = useMemo(() => {
		const tab = VENDOR_TABS.find((t) => businessTypes?.includes(t.id))
		return tab?.Component
	}, [businessTypes])

	const handleSubmit = () => {
		/* TODO:: Add submit logic here with surveyData */
		closeAllModals()
		dispatch(clearSurveyData())
	}

	if (!businessTypes.length || !ActiveComponent) return null

	return (
		<CommonModal
			open={activeModal}
			handleClose={closeAllModals}
			heading="Vendor Survey"
			subHeading="Complete the details below to plan your perfect day"
			footerContent={
				<ButtonCustom
					variant="default"
					size="lg"
					onClick={handleSubmit}
				>
					Submit
				</ButtonCustom>
			}
			modalInner={styles.modalBody}
		>
			<div className={styles.VendorModalBody}>
				<div className={styles.VendorModalBodyContent}>
					{ActiveComponent && <ActiveComponent />}
				</div>
			</div>
		</CommonModal>
	)
}

export default Modal
